<template>
  <div id="slide_box" class="slide6">
    <div id="slide_content" :style="{ background: siteCodeInfo[0].BACK_COLOR }">
      <div class="slide_block" id="slide6">
        <div class="slide_animate_block">
          <form>
            <div class="bg" :style="{ background: siteCodeInfo[0].BACK_COLOR }">
              <div class="wrap01">
                <h2 class="stitle"><span>回収先のお名前・連絡先を</span><br><span>ご記入ください。</span></h2>
                <CommonErrorMsgArea />

                <div v-if="siteCodeInfo[0].BIZ_FLG == '1'" class="wrap01">
                  <div class="form_block_05">
                    <div class="input_name_box">
                      <div class="input_name_block">
                        <p>●会社名・屋号</p>
                      </div>
                    </div>
                    <div>
                      <p><input type="text" class="form-InputText" v-model="companyName" maxlength="125"></p>
                    </div>
                    <p class="error" v-if="error.required_apply_company_name">{{ $msg.ERROR.MSG_0026 }}</p>
                  </div>
                  <div class="form_block_05">
                    <div class="input_name_box">
                      <div class="input_name_block">
                        <p>●お申込み者 所属部署・役職</p>
                      </div>
                    </div>
                    <div>
                      <p><input type="text" class="form-InputText" v-model="department" maxlength="125"></p>
                    </div>
                    <p class="error" v-if="error.required_apply_department">{{ $msg.ERROR.MSG_0027 }}</p>
                  </div>
                  <div class="form_block_05">
                    <div class="input_name_box">
                      <div class="input_name_block">
                        <p>●お申込み者名</p>
                      </div>
                    </div>
                    <div class="input_box_01">
                      <p><input type="text" id="name01" class="form-InputText" placeholder="東京"
                          @input="update_furigana_sei" v-model="name.sei_kj" maxlength="32"></p>
                      <p><input type="text" id="name02" class="form-InputText" placeholder="太郎"
                          @input="update_furigana_mei" v-model="name.mei_kj" maxlength="32"></p>
                    </div>
                    <p class="error" v-if="error.required_apply_sei_mei_kj">{{ $msg.ERROR.MSG_0007 }}</p>
                    <p class="error" v-if="error.invalid_apply_sei_mei_kj">{{ $msg.ERROR.MSG_0008 }}</p>
                  </div>
                  <div class="form_block_05">
                    <div class="input_name_box">
                      <div class="input_name_block">
                        <p>●お申込み者名<span class="kakko">（カナ）</span></p>
                      </div>
                    </div>
                    <div class="input_box_01">
                      <p><input type="text" id="kana01" class="form-InputText" placeholder="トウキョウ"
                          v-model="name.sei_kn" maxlength="125"></p>
                      <p><input type="text" id="kana02" class="form-InputText" placeholder="タロウ"
                          v-model="name.mei_kn" maxlength="125"></p>
                    </div>
                    <p class="error" v-if="error.required_apply_sei_mei_kn">{{ $msg.ERROR.MSG_0009 }}</p>
                    <p class="error" v-if="error.invalid_apply_sei_mei_kn">{{ $msg.ERROR.MSG_0010 }}</p>
                  </div>
                  <div class="form_block_05">
                    <div class="input_name_box">
                      <div class="input_name_block">
                        <p>●電話番号<span class="kakko">（半角）</span></p>
                      </div>
                    </div>
                    <div class="input_box_02">
                      <p><input type="tel" name="tel" class="form-InputText" placeholder="0123456789（ハイフン不要）"
                          @input="pickupTell = delete_hyphen($event)" :value="pickupTell" maxlength="11"></p>
                    </div>
                    <p class="error" v-if="error.required_apply_pickupTell">{{ $msg.ERROR.MSG_0032 }}</p>
                    <p class="error" v-if="error.invalid_apply_pickupTell">{{ $msg.ERROR.MSG_0033 }}</p>
                  </div>
                  <div class="form_block_05">
                    <div class="input_name_box">
                      <div class="input_name_block">
                        <p>●メールアドレス<span class="kakko">（半角）</span></p>
                      </div>
                    </div>
                    <div class="input_box_02">
                      <p><input type="text" name="email" class="form-InputText" placeholder="sg_renet@renet.jp"
                          v-model="email" maxlength="50" @change="formatToLowerEmail"></p>
                    </div>
                    <p class="error" v-if="error.required_apply_email">{{ $msg.ERROR.MSG_0014 }}</p>
                    <p class="error" v-if="error.invalid_apply_email">{{ $msg.ERROR.MSG_0015 }}</p>
                  </div>
                  <div class="form_block_08">
                    <label class="form_Checkbox">
                      <input class="ckboxInput" type="checkbox" name="info" v-model="checkContractor">
                      <span class="dummyInput"></span>
                      <span class="labelText">お申込み者がご契約者名と異なる。</span>
                    </label>
                  </div>
                  <div v-show="checkContractor" class="wrap05 form_box">
                    <div class="form_block_05">
                      <div class="input_name_box">
                        <div class="input_name_block">
                          <p>●ご契約者 会社名・屋号</p>
                        </div>
                      </div>
                      <div>
                        <p><input type="text" class="form-InputText" v-model="contractCompanyName" maxlength="125"></p>
                      </div>
                      <p class="error" v-if="error.required_contract_company_name">{{ $msg.ERROR.MSG_0026 }}</p>
                    </div>
                    <div class="form_block_05">
                      <div class="input_name_box">
                        <div class="input_name_block">
                          <p>●ご契約者 所属部署・役職</p>
                        </div>
                      </div>
                      <div>
                        <p><input type="text" class="form-InputText" v-model="contractDepartment" maxlength="125"></p>
                      </div>
                      <p class="error" v-if="error.required_contract_department">{{ $msg.ERROR.MSG_0027 }}</p>
                    </div>
                    <div class="form_block_05">
                      <div class="input_name_box">
                        <div class="input_name_block">
                          <p>●ご契約者名</p>
                        </div>
                      </div>
                      <div class="input_box_01">
                        <p><input type="text" id="contractorName01" class="form-InputText" placeholder="東京"
                            @input="update_contractor_furigana_sei" v-model="contractorName.sei_kj" maxlength="32"></p>
                        <p><input type="text" id="contractorName02" class="form-InputText" placeholder="太郎"
                            @input="update_contractor_furigana_mei" v-model="contractorName.mei_kj" maxlength="32"></p>
                      </div>
                      <p class="error" v-if="error.required_contract_sei_mei_kj">{{ $msg.ERROR.MSG_0007 }}</p>
                      <p class="error" v-if="error.invalid_contract_sei_mei_kj">{{ $msg.ERROR.MSG_0008 }}</p>
                    </div>
                    <div class="form_block_05">
                      <div class="input_name_box">
                        <div class="input_name_block">
                          <p>●ご契約者名<span class="kakko">（カナ）</span></p>
                        </div>
                      </div>
                      <div class="input_box_01">
                        <p><input type="text" id="contractorKana01" class="form-InputText" placeholder="トウキョウ"
                            v-model="contractorName.sei_kn" maxlength="125"></p>
                        <p><input type="text" id="contractorKana02" class="form-InputText" placeholder="タロウ"
                            v-model="contractorName.mei_kn" maxlength="125"></p>
                      </div>
                      <p class="error" v-if="error.required_contract_sei_mei_kn">{{ $msg.ERROR.MSG_0009 }}</p>
                      <p class="error" v-if="error.invalid_contract_sei_mei_kn">{{ $msg.ERROR.MSG_0010 }}</p>
                    </div>
                    <div class="form_block_05">
                      <div class="input_name_box">
                        <div class="input_name_block">
                          <p>●ご契約者 会社郵便番号</p>
                        </div>
                      </div>
                      <div>
                        <p><input type="text" class="form-InputText" v-model="contractCompanyZipcode" maxlength="7"></p>
                      </div>
                      <p class="error" v-if="error.required_contract_company_zipcode">{{ $msg.ERROR.MSG_0028 }}</p>
                      <p class="error" v-if="error.invalid_contract_company_zipcode">{{$msg.ERROR.MSG_0034}}</p>
                    </div>
                    <div class="form_block_05">
                      <div class="input_name_box">
                        <div class="input_name_block">
                          <p>●ご契約者 会社住所</p>
                        </div>
                      </div>
                      <div>
                        <p><input type="text" class="form-InputText" v-model="contractCompanyAddress" maxlength="500">
                        </p>
                      </div>
                      <p class="error" v-if="error.required_contract_company_address">{{ $msg.ERROR.MSG_0029 }}</p>
                    </div>
                    <div class="form_block_05">
                      <div class="input_name_box">
                        <div class="input_name_block">
                          <p>●ご契約者 会社電話番号<span class="kakko">（半角）</span></p>
                        </div>
                      </div>
                      <div class="input_box_02">
                        <p><input type="tel" name="tel" class="form-InputText" placeholder="0123456789（ハイフン不要）"
                            @input="contractCompanyTell = delete_hyphen($event)" :value="contractCompanyTell" maxlength="11"></p>
                      </div>
                      <p class="error" v-if="error.required_contract_tell">{{ $msg.ERROR.MSG_0032 }}</p>
                      <p class="error" v-if="error.invalid_contract_tell">{{ $msg.ERROR.MSG_0033 }}</p>
                    </div>
                    <div class="form_block_05">
                    </div>
                  </div>
                  <div class="form_block_05">
                    <div class="input_name_box">
                      <div class="input_name_block">
                        <p>●従業員数</p>
                      </div>
                    </div>
                    <div class="input_box_05">
                      <p class="select01">
                        <select class="form-Select" v-model="selectEmployee">
                          <option v-for="employee in employees" :key="employee.CODE" v-bind:value="employee.CODE">{{
                            employee.CODE_NM }}</option>
                        </select>
                      </p>
                    </div>
                    <p class="error" v-if="error.required_employee">{{ $msg.ERROR.MSG_0030 }}</p>
                  </div>
                  <div class="form_block_05">
                    <div class="input_name_box">
                      <div class="input_name_block">
                        <p>●業種</p>
                      </div>
                    </div>
                    <div class="input_box_05">
                      <p class="select01">
                        <select class="form-Select" v-model="selectIndustry">
                          <option v-for="industry in industries" :key="industry.CODE" v-bind:value="industry.CODE">{{
                            industry.CODE_NM }}</option>
                        </select>
                      </p>
                    </div>
                    <p class="error" v-if="error.required_industry">{{ $msg.ERROR.MSG_0031 }}</p>
                  </div>
                </div>

                <div v-else class="wrap05 form_box">
                  <div class="form_block_05">
                    <div class="input_name_box">
                      <div class="input_name_block">
                        <p>●お名前</p>
                      </div>
                    </div>
                    <div class="input_box_01">
                      <p><input type="text" id="name01" class="form-InputText" placeholder="東京"
                          @input="update_furigana_sei" v-model="name.sei_kj" maxlength="32"></p>
                      <p><input type="text" id="name02" class="form-InputText" placeholder="太郎"
                          @input="update_furigana_mei" v-model="name.mei_kj" maxlength="32"></p>
                    </div>
                    <p class="error" v-if="error.required_sei_mei_kj">{{ $msg.ERROR.MSG_0007 }}</p>
                    <p class="error" v-if="error.invalid_sei_mei_kj">{{ $msg.ERROR.MSG_0008 }}</p>
                  </div>
                  <div class="form_block_05">
                    <div class="input_name_box">
                      <div class="input_name_block">
                        <p>●お名前<span class="kakko">（カナ）</span></p>
                      </div>
                    </div>
                    <div class="input_box_01">
                      <p><input type="text" name="kana01" id="kana01" class="form-InputText" placeholder="トウキョウ"
                          v-model="name.sei_kn" maxlength="125"></p>
                      <p><input type="text" name="kana02" id="kana02" class="form-InputText" placeholder="タロウ"
                          v-model="name.mei_kn" maxlength="125"></p>
                    </div>
                    <p class="error" v-if="error.required_sei_mei_kn">{{ $msg.ERROR.MSG_0009 }}</p>
                    <p class="error" v-if="error.invalid_sei_mei_kn">{{ $msg.ERROR.MSG_0010 }}</p>
                  </div>
                  <div class="form_block_05">
                    <div class="input_name_box">
                      <div class="input_name_block">
                        <p>●携帯電話番号<span class="kakko">（半角）</span></p>
                      </div>
                    </div>
                    <div class="input_box_02">
                      <p><input type="tel" name="tel" class="form-InputText" placeholder="09012345678（ハイフン不要）"
                          @input="pickupTell = delete_hyphen($event)" :value="pickupTell" maxlength="11"></p>
                    </div>
                    <p class="error" v-if="error.required_pickupTell">{{ $msg.ERROR.MSG_0011 }}</p>
                    <p class="error" v-if="error.invalid_pickupTell">{{ $msg.ERROR.MSG_0012 }}</p>

                    <p class="sub_txt">※携帯電話が無い方は、固定電話の番号を入力してください。</p>
                  </div>
                  <div class="form_block_05" style="display: none;">
                    <div class="input_name_box">
                      <div class="input_name_block">
                        <p>●ご自宅電話番号<span class="kakko">（半角）</span></p>
                      </div>
                    </div>
                    <div class="input_box_02">
                      <p><input type="number" name="tel_home" class="form-InputText" placeholder="0123456789（ハイフン不要）"
                          v-model="pickupTell2" maxlength="11"></p>
                    </div>
                    <p class="error" v-if="error.invalid_pickupTell2">{{ $msg.ERROR.MSG_0013 }}</p>
                  </div>
                  <div class="form_block_05">
                    <div class="input_name_box">
                      <div class="input_name_block">
                        <p>●メールアドレス<span class="kakko">（半角）</span></p>
                      </div>
                    </div>
                    <div class="input_box_02">
                      <p><input type="text" name="email" class="form-InputText" placeholder="call@renet.jp"
                          v-model="email" maxlength="50" @change="formatToLowerEmail"></p>
                    </div>
                    <p class="error" v-if="error.required_email">{{ $msg.ERROR.MSG_0014 }}</p>
                    <p class="error" v-if="error.invalid_email">{{ $msg.ERROR.MSG_0015 }}</p>
                  </div>
                  <div class="form_block_05">
                    <div class="input_name_box">
                      <div class="input_name_block">
                        <p>●生年月日</p>
                      </div>
                    </div>
                    <div class="input_box_03">
                      <p class="select01">
                        <select class="form-Select form-Select-birth-year" id="birthYear" name="birthYear"
                          v-model="birthday.year">
                          <option v-for="year in years" :key="year.code" v-bind:value="year.code">{{ year.label }}
                          </option>
                        </select>
                      </p>
                      <p class="select_txt">年</p>
                      <p class="select02">
                        <select class="form-Select" id="birthMonth" name="birthMonth" v-model="birthday.month">
                          <option v-for="month in months" :key="month" v-bind:value="month">{{ month }}</option>
                        </select>
                      </p>
                      <p class="select_txt">月</p>
                      <p class="select03">
                        <select class="form-Select" id="birthDay" name="birthDay" v-model="birthday.date">
                          <option v-for="date in dates" :key="date" v-bind:value="date">{{ date }}</option>
                        </select>
                      </p>
                      <p class="select_txt">日</p>
                    </div>
                    <p class="error" v-if="error.required_birthday">{{ $msg.ERROR.MSG_0016 }}</p>
                    <p class="error" v-if="error.invalid_birthday">{{ $msg.ERROR.MSG_0017 }}</p>
                    <p class="sub_txt">※ご本人様確認時等に使用させていただきます。</p>
                  </div>
                  <div class="form_block_05">
                    <div class="input_name_box">
                      <div class="input_name_block">
                        <p>●性別</p>
                      </div>
                    </div>
                    <div class="form-Radio-02 input_box_04">
                      <label v-for="item in genderList" :key="item.value">
                        <input type="radio" name="gender" v-model="gender" :value="item.value"
                          :checked="gender == item.value">
                        <span class="input_txt" :style="{backgroundColor :gender == item.value? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :gender == item.value? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">{{ item.name }}</span>
                      </label>
                    </div>
                    <p class="error" v-if="error.required_gender">{{ $msg.ERROR.MSG_0018 }}</p>
                  </div>
                </div>
                <p class="next_page"><button type="button" class="form-Button-01" :style="{backgroundColor : siteCodeInfo[0].NEXT_PAGE_BTN_COLOR}"
                    @click="submitCustomerForm">確認画面へ</button></p>
                <div v-if="enqueteMaster.length > 0" class="form_block_05">
                  <hr>
                  <div class="enquete-box">
                    <p>▼アンケートにご協力ください（任意回答）</p>
                    <div v-for="(qa, qa_index) in enqueteMaster" :key="qa_index" class="qa">
                      <div class="question">
                        <div class="question_no">Q{{ qa_index + 1 }}</div>
                        <div class="question_content">
                          <pre>{{ qa.question.QUESTION_CONTENT }}</pre>
                          <pre>{{ qa.question.QUESTION_NOTES }}</pre>
                        </div>
                      </div>
                      <hr>
                      <div class="answer" v-for="(answer, idx_a) in qa.answers" :key="idx_a">
                        <div>
                          <input v-if="qa.question.QUESTION_METHOD === 1" type="checkbox"
                            v-model="selected['question_' + qa.question.ENQUETE_QUESTION_ID]"
                            :value="answer.ENQUETE_ANSWER_ID" :id="'answer_' + answer.ENQUETE_ANSWER_ID">
                          <input v-if="qa.question.QUESTION_METHOD === 2" type="radio"
                            v-model="selected['question_' + qa.question.ENQUETE_QUESTION_ID]"
                            :value="answer.ENQUETE_ANSWER_ID" :id="'answer_' + answer.ENQUETE_ANSWER_ID">
                        </div>
                        <div class="other">
                          <label v-if="qa.question.QUESTION_METHOD !== 3" :for="'answer_' + answer.ENQUETE_ANSWER_ID"
                            class="answer_content">
                            <pre>{{ answer.ANSWER_CONTENT }}</pre>
                          </label>
                          <div v-if="qa.question.QUESTION_METHOD === 3">
                            <textarea class="free_input"
                              v-model="freeInput['answer_' + answer.ENQUETE_ANSWER_ID]"></textarea>
                          </div>
                          <div v-else-if="answer.FREE_INPUT_FLG === 1">
                            <textarea class="other_free_input"
                              :disabled="getDisabled(qa.question.ENQUETE_QUESTION_ID, answer.ENQUETE_ANSWER_ID)"
                              v-model="freeInput['answer_' + answer.ENQUETE_ANSWER_ID]"></textarea>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="link_box">
                  <p class="back_page"><span class="form-Button-back move_slide move_category" data-toslide="slide5"
                      data-categorynum="0" @click="pageBack">戻る</span></p>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerForm from '../../js/CustomerForm'
import CommonErrorMsgArea from '@/components/sp/CommonErrorMsgArea'

export default {
  props: {
    siteCodeInfo: Array,
    enqueteMaster: Array
  },
  data() {
    return {
      name: {
        sei_kj: '',
        mei_kj: '',
        sei_kn: '',
        mei_kn: ''
      },
      autokanaSei: '',
      autokanaMei: '',
      autokanaContractorSei: '',
      autokanaContractorMei: '',
      pickupTell: '',
      pickupTell2: '',
      email: '',
      years: [],
      months: [],
      dates: [],
      birthday: {
        year: '1970',
        month: '1',
        date: '1'
      },
      gender: '',
      genderList: CustomerForm.common.constant.GENDER_LIST,
      error: {
        required_sei_mei_kj: false,
        invalid_sei_mei_kj: false,
        required_sei_mei_kn: false,
        invalid_sei_mei_kn: false,
        required_pickupTell: false,
        invalid_pickupTell: false,
        invalid_pickupTell2: false,
        required_email: false,
        invalid_email: false,
        required_birthday: false,
        invalid_birthday: false,
        required_gender: false,
        required_apply_company_name: false,
        required_apply_department: false,
        required_apply_sei_mei_kj: false,
        invalid_apply_sei_mei_kj: false,
        required_apply_sei_mei_kn: false,
        invalid_apply_sei_mei_kn: false,
        required_apply_pickupTell: false,
        invalid_apply_pickupTell: false,
        required_apply_email: false,
        invalid_apply_email: false,
        required_contract_company_name: false,
        required_contract_department: false,
        required_contract_sei_mei_kj: false,
        invalid_contract_sei_mei_kj: false,
        required_contract_sei_mei_kn: false,
        invalid_contract_sei_mei_kn: false,
        required_contract_company_zipcode: false,
        invalid_contract_company_zipcode: false,
        required_contract_company_address: false,
        required_contract_tell: false,
        invalid_contract_tell: false,
        required_employee: false,
        required_industry: false
      },
      selected: CustomerForm.initialSelected(this.enqueteMaster),
      freeInput: CustomerForm.initialFreeInput(this.enqueteMaster),
      contractorName: {
        sei_kj: '',
        mei_kj: '',
        sei_kn: '',
        mei_kn: ''
      },
      companyName: '',
      department: '',
      checkContractor: false,
      contractCompanyName: '',
      contractDepartment: '',
      contractCompanyZipcode: '',
      contractCompanyAddress: '',
      contractCompanyTell: '',
      employees: [],
      industries: [],      
      selectEmployee: '',
      selectIndustry: ''
    }
  },
  created() {
    CustomerForm.inputRetention(this)
  },
  mounted() {
    CustomerForm.createBirthday(this)
    CustomerForm.autoKanaBind(this)
  },
  methods: {
    update_furigana_sei() {
      CustomerForm.update_furigana_sei(this)
    },
    update_furigana_mei() {
      CustomerForm.update_furigana_mei(this)
    },
    update_contractor_furigana_sei () {
        CustomerForm.update_contractor_furigana_sei(this)
    },
    update_contractor_furigana_mei () {
        CustomerForm.update_contractor_furigana_mei(this)
    },
    submitCustomerForm() {
      CustomerForm.submitCustomerForm(this, CustomerForm.common.constant.CONFIRMATION_SCREEN_PATH)
    },
    pageBack() {
      CustomerForm.common.pageBack(this, CustomerForm.common.constant.SPECIFIC_DATETIME_PATH)
    },
    delete_hyphen(event) {
      return CustomerForm.deleteHyphen(event.target.value)
    },
    getDisabled(questionId, answerId) {
      return CustomerForm.getDisabled(this, questionId, answerId)
    },
    formatToLowerEmail() {
        // フォーカスアウト（change）のタイミングでデータを小文字に上書き
        CustomerForm.formatToLowerEmail(this);
    }
  },
  components: { CommonErrorMsgArea }
}
</script>
